import React, { useCallback, useMemo, useState } from "react";
import { Publications } from "../publications";
import { Checkbox, CircularProgress, MenuItem, Typography } from "@mui/material";
import { KababMenu } from "shared/components/Menu/KababMenu";
import { publicationsClient } from "../client/publicationsClient";
import { formatDuration, intervalToDuration } from "date-fns";

export const AppOption = (props: AppOptionProps) => {
  const { app, isChecked, onCheckChange, publication, onUnpublished } = props;
  const [isUnpublishing, setIsUnpublishing] = useState<boolean>(false);

  const publishedDurationString = useMemo(() => {
    if (!publication) {
      return "";
    }

    const duration = intervalToDuration({
      start: new Date(publication.updatedAt),
      end: new Date(),
    });
    return `Last published ${formatDuration(duration)} ago`;
  }, [publication]);

  const handleUnpublish = useCallback(async () => {
    if (!publication) {
      return;
    }

    try {
      setIsUnpublishing(true);
      await publicationsClient.unpublishSurvey(app.id, publication.id);
      onUnpublished(app.id);
    } catch (e) {
      console.error(e);
    } finally {
      setIsUnpublishing(false);
    }
  }, [app.id, onUnpublished, publication]);

  return (
    <div className="module-app-option _d-flex-ali-center-jc-sb">
      <div className="_d-flex-ali-center">
        <Checkbox
          checked={isChecked || !!publication}
          onChange={(e) => onCheckChange(e.target.checked)}
          disabled={!!publication}
        />
        <div>
          <Typography>{app.name}</Typography>
          {publication && (
            <Typography variant="body2" color={isUnpublishing ? "text.secondary" : "success.main"}>
              {isUnpublishing ? (
                <>
                  <CircularProgress size={10} color="secondary" sx={{ mr: 1 }} />
                  Unpublishing
                </>
              ) : (
                publishedDurationString
              )}
            </Typography>
          )}
        </div>
      </div>

      {publication && (
        <KababMenu
          closeOnClick
          items={[
            <MenuItem key="Unpublish" onClick={handleUnpublish}>
              <Typography color="error.main">Unpublish</Typography>
            </MenuItem>,
          ]}
        />
      )}
    </div>
  );
};

export interface AppOptionProps {
  onCheckChange: (isChecked: boolean) => void;
  isChecked: boolean;
  app: Publications.App;
  publication?: Publications.Publication;
  onUnpublished: (appId: string | number) => void;
}
